import { render, staticRenderFns } from "./PlayInput.vue?vue&type=template&id=1ce136ec&scoped=true"
import script from "./PlayInput.vue?vue&type=script&lang=js"
export * from "./PlayInput.vue?vue&type=script&lang=js"
import style0 from "./PlayInput.vue?vue&type=style&index=0&id=1ce136ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce136ec",
  null
  
)

export default component.exports